import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { getWaitingAreaNameToShortURL } from '../../../../businessLogic/selfProvision';
import Txt from '../../../inputs/textInput.js';
import { setCreateWAForm, setCreateWAFormTrim } from '../../../../actions/waitingArea.js';
import objectAssign from 'object-assign';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import { forceValidation } from '../../../../businessLogic/validation.js';

export default function CenterPanel(props) {
  const waitingAreaUrlRef = useRef('waitingAreaUrl');
  const waitingAreaTypeRef = useRef('waitingAreaType');
  const dispatch = useDispatch();

  useEffect(() => {
    //register the delegate event
    window.addEventListener('globalMessageHidden', globalMessageHidden);
    //Unmount the event
    return () => {
      //unRegister the delegate event
      window.removeEventListener('globalMessageHidden', globalMessageHidden);
    };
  }, []);

  //this function is a delegate event, and is fired when global message is hidden
  const globalMessageHidden = (e) => {
    if (e.detail && e.detail.text.indexOf('Waiting Area with that name') > 0) {
      window.$('input[name="waitingAreaName"]').focus();
    } else if (e.detail && e.detail.text.indexOf('Waiting Area with that URL') > 0) {
      window.$('input[name="waitingAreaUrl"]').focus();
    }
  };

  const onInputElementBlur = () => {
    dispatch(setCreateWAFormTrim());
  };
  const waitingAreaNameChanged = (value) => {
    dispatch(setCreateWAForm(createWAFormUpdated('waitingAreaName', value)));
  };
  const waitingAreaDescriptionChanged = (value) => {
    dispatch(setCreateWAForm(createWAFormUpdated('waitingAreaDescription', value)));
  };
  const waitingAreaURLChanged = (value) => {
    // Replace all forward slashes with single forward slash
    value = value.replace(/[\/]{1,}/g, '/');
    dispatch(setCreateWAForm(createWAFormUpdated('waitingAreaUrl', value)));
  };
  const waitingAreaTypeChanged = (value) => {
    dispatch(setCreateWAForm(createWAFormUpdated('networkTypeId', value)));
    setTimeout(() => {
      forceValidation(undefined, undefined, 'createWAForm');
    }, 500);
  };

  const waNameFocusOut = (value) => {
    onInputElementBlur();
    if (
      (!props.createWAForm.waitingAreaUrl || props.createWAForm.waitingAreaUrl.length == 0) &&
      value.length > 0 &&
      value.length <= 50
    ) {
      let shortUrl = getWaitingAreaNameToShortURL(value);
      dispatch(setCreateWAForm(createWAFormUpdated('waitingAreaUrl', shortUrl)));
      const waitingAreaRefLocal = waitingAreaUrlRef.current;
      const networkTypeId = props.createWAForm.networkTypeId;
      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        waitingAreaRefLocal.handleChange(shortUrl);
        if (!networkTypeId) {
          forceValidation(undefined, undefined, 'createWAForm');
        }
      }, 300);
    }
  };
  const createWAFormUpdated = (property, value) => {
    return objectAssign({}, props.createWAForm, { [property]: value });
  };

  return (
    <div className="ui form mrbml">
      <div className="pdts">
        <ValidMe
          validmefor="length@3-50"
          validmemessage={APP.LANGUAGE.Errors.WaitingAreaInValidNameLength}
          trim={true}
          group="createWAForm"
        >
          <Txt
            tabIndex="1"
            maxLength={50}
            focusme="true"
            noTitle
            name="waitingAreaName"
            value={props.createWAForm.waitingAreaName}
            onChange={waitingAreaNameChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.ServiceName}
            onBlur={waNameFocusOut}
          />
        </ValidMe>
        <label className=" placeholder-label no-bold mrtxs  div-like color-placeholder">
          {APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrl}
        </label>
        <div className="center-flex display-flex  flex-wrap">
          <div className="title-sms small-margin mrrxxs">{props.organisation.shortUrlDomain}</div>

          <ValidMe validmefor="shortURLPath" trim={true} group="createWAForm" fieldClasses="flex-grow-fill-rest mrtxxs">
            <Txt
              tabIndex="2"
              maxLength={128}
              onBlur={onInputElementBlur}
              name="waitingAreaUrl"
              noTitle
              ref={waitingAreaUrlRef}
              notRenderPlaceholderAsTitle={true}
              value={props.createWAForm.waitingAreaUrl}
              onChange={waitingAreaURLChanged}
              placeholder={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrlPlaceHolder}
            />
          </ValidMe>
        </div>
        <Txt
          tabIndex="3"
          maxLength={200}
          name="waitingAreaDescription"
          fieldClasses="input mrbnull"
          value={props.createWAForm.waitingAreaDescription}
          onChange={waitingAreaDescriptionChanged}
          placeholder={APP.LANGUAGE.SelfProvisionCreateWA.Description}
        />
        <div className="mrbm placeholder-label">
          <span>{APP.LANGUAGE.SelfProvisionCreateWA.DescriptionHint}</span>
        </div>
        <div className="waiting-area-type mrbm">
          <div className="bold title-sms small-margin mrrxxs">
            {APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUsage}
          </div>
          {/* Adding validation on hidden element just to invalidate form which will make save button disabled when condition is not met
              as if we add it over Txt of type radio then it just hides the
              control */}
          <ValidMe
            validmefor="condition"
            group="createWAForm"
            condition={(networkTypeIdValue) => {
              return networkTypeIdValue > 0;
            }}
            validmemessagecondition={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUsageErrorTooltip}
            fieldClasses="mrtxxs mrlm"
          >
            <input
              type="text"
              ref={waitingAreaTypeRef}
              value={props.createWAForm.networkTypeId}
              name="waitingAreaType"
              className="no-border"
              disabled
            />
          </ValidMe>
        </div>
        <div className="center-flex display-flex  flex-wrap">
          <div>
            <Txt
              tabIndex="4"
              name="radioGroup"
              text={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaRegularConsulations}
              radio
              checked={props.createWAForm.networkTypeId === NetworkTypes.WaitingArea}
              onChange={() => waitingAreaTypeChanged(NetworkTypes.WaitingArea)}
            />
          </div>
          <div className="mrbm placeholder-label mrll" style={{ paddingLeft: '2px' }}>
            <span>{APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaRegularConsultationsHint}</span>
          </div>
          {props.createWAForm.isGroupConsultationFeatureEnabled ? (
            <React.Fragment>
              <div>
                <Txt
                  tabIndex="5"
                  name="radioGroup"
                  text={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaGroupConsultations}
                  radio
                  checked={props.createWAForm.networkTypeId === NetworkTypes.GroupConsultation}
                  onChange={() => waitingAreaTypeChanged(NetworkTypes.GroupConsultation)}
                />
              </div>
              <div className="mrbm placeholder-label mrll" style={{ paddingLeft: '2px' }}>
                <span>{APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaGroupConsultationsHint}</span>
              </div>
            </React.Fragment>
          ) : (
            ''
          )}
        </div>
        <div className="mrbxxl  hide-on-small-ress " />
      </div>
    </div>
  );
}
